<template>
  <div class="icon-link-slider">
    <h3 class="section-title">{{ title }}</h3>
    <v-carousel
      :continuous="false"
      :cycle="cycle"
      height="auto"
      :show-arrows="false"
      :delimiter-icon="circleImage"
      :interval="interval"
      hide-delimiter-background>
      <v-carousel-item v-for="(slide, i) in slides" :key="i">
        <div class="icon-link-banner">
          <div class="link-item" v-for="item in slide.slideContent"
                                 :key="item.index">
            <div class="item-icon">
              <div class="item-icon__image">
                <a v-bind:href="item.tb_url" target="_blank">
                  <img :src="item.tb_pic" :alt="item.tb_name" width="50px" height="50px"/>
                </a>
              </div>
            </div>
            <a v-bind:href="item.tb_url" target="_blank">
              <div class="item-icon__title">{{ item.tb_name }}</div>
            </a>
          </div>
        </div>
      </v-carousel-item>
    </v-carousel>
  </div>
</template>

<script>
export default {
  name: 'IconLinkSlider',
  props: {
    title:String,
    list:Array,
    cycle: {
      type: Boolean,
      default: false,
    },
    interval: {
      type: Number,
      default: 7000,
    },
  },
  data: () => ({
    iconLinks: [],
    circleImage: '',
    slides: [{
        slideContent: [{
            tb_pic: '../../images/placholder_1200.svg',
            tb_url: '',
            tb_name: '',
          }
        ],
      },
    ],
  }),
  mounted() {
    this.iconLinks = this.list
    this.getData()
  },
  methods: {
    getData() {
      this.getSlides();
    },
    getSlides() {
      this.slides.pop()
      this.iconLinks.forEach((item, index) => {
        if (index % 6 === 0) {
          this.slides.push({
            index: this.slides.length,
            slideContent: [],
          })
        }
        this.slides[this.slides.length - 1].slideContent.push(item)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.section-title {
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0.56px;
  color: #383838;
  margin-bottom: 10px;
  margin-top: 10px;
}
.icon-link-slider {
  border-radius: 16px;
  margin-bottom: 5px;
  .icon-link-banner {
    display: flex;
    background-color: #f3f5f8;
    width: 100%;
    height: 223px;
    padding: 20px;
    position: relative;
    flex-wrap: wrap;

    .link-item {
      text-align: center;
      display: inline-block;
      width: 33.3333%;
      margin-bottom: 20px;

      .item-icon {
        text-align: center;
        width: 84px;
        margin: 0 auto 5px auto;

        &__image {
          justify-content: center;
          align-items: center;
          background: white;
          height: 50px;
          width: 50px;
          border-radius: 1000px;
          margin: auto;
          overflow: hidden;
          // background:blue;
          background-size: contain;
          img {
            width: 100%;
          }
        }

        &__title {
          width: 84px;
          text-align: center;
          margin: auto;
          font-size: 14px;
          letter-spacing: 0.44px;
          text-align: center;
          color: #383838;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
  }

  ::v-deep .v-carousel {
    border-radius: 16px;
    z-index: 0;
    .v-carousel__controls {
      height: 25px;
      .v-item-group {
        .v-carousel__controls__item.v-btn {
          margin: 0 5px 0 0;
          width: 5px;
          height: 5px;
          background: #bbbbbb;
          opacity: 1;

          &.v-btn--active {
            background: #767676;
          }

          &::before {
            opacity: 0;
          }
        }
      }
    }
  }
}
</style>